module.exports = __webpack_public_path__ + "img/logo.3d857e94.png";